import http from 'hub-http/clients/apiClient';
import { queryQuickFetch } from './earlyRequestHelper';
import { EARLY_REQUESTER_KEYS } from '../constants/EarlyRequesterKeys';
const OWNER_URI = 'owners/v2/owners';
const INTERNAL_REPORTING_API = 'forecasting/v1/internal/reporting';
export const fetchOwners = () => queryQuickFetch(EARLY_REQUESTER_KEYS.OWNERS, () => http.get(OWNER_URI, {
  query: {
    includeInactive: true
  }
}));
export const fetchValidForecastingOwners = month => {
  return http.get(`${INTERNAL_REPORTING_API}?month=${month}`);
};